
import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Loading } from "../../../../componentes/loading/loading";

export default function ResumoStatus({ loading, data, filtrar, alterarStatus }) {
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);
  const [labels, setLabels] = useState([]);

  useEffect(() => {
    if (data?.countByStatus) {
      const statusLabels = Object.keys(data.countByStatus);
      const valores = Object.values(data.countByStatus);

      setLabels(statusLabels);

      setChartOptions({
        chart: {
          type: "donut",
          toolbar: { show: true },
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const index = config.dataPointIndex;
              const label = statusLabels[index];
              alterarStatus(label);
            }
          }
        },
        labels: statusLabels,
        legend: {
          position: "bottom",
          fontSize: "14px"
        },
        stroke: {
          show: false,
          width: 0
        },
        colors: [
          "#22C55E", // Aberto
          "#3B82F6", // Finalizado
          "#F97316"  // Cancelado
        ],
        tooltip: {
          y: {
            formatter: (value) => `${value} solicitações`
          }
        }
      });

      setChartSeries(valores);
    } else {
      setChartSeries([]);
    }
  }, [data, filtrar]);

  return (
    <div className="bg-card border border-border rounded-lg shadow-card p-4 lg:col-span-1">
      <h3 className="text-lg font-display font-semibold text-foreground mb-1">
        Distribuição por Status
      </h3>
      <label className="text-muted-foreground text-sm">
        Visão geral dos processos por situação atual.
      </label>
      <div className="h-64">
        {!loading ? (
          data.solicitacoes.length > 0 && chartSeries.length > 0 ? (
            <Chart
              options={chartOptions}
              series={chartSeries}
              type="donut"
              height="100%"
            />
          ) : (
            "Não existem dados disponíveis para o intervalo selecionado."
          )
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
}
